// extracted by css-extract-rspack-plugin
module.exports =  {"container":"PresentationSource-xcxU__container"};